import { createSlice } from "@reduxjs/toolkit";

const initialOrganizationState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    organizationForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const organizationSlice = createSlice({
    name: "organizations",
    initialState: initialOrganizationState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getOrganizationById
        organizationFetched: (state, action) => {
            state.actionsLoading = false;
            state.organizationForEdit = action.payload.organizationForEdit;
            state.floorPlans = action.payload.organizationForEdit.floorPlans;
            state.error = null;

        },
        // getOrganizationChart
        organizationChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.organizationChart = action.payload.organizationChart;
            state.error = null;

        },
        // getOrganizationChart
        organizationHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.organizationChartHour = action.payload.organizationChartHour;
            state.error = null;

        },
        // getOrganizationChart
        organizationHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.organizationChartHourZone = action.payload.organizationChartHourZone;
            state.error = null;

        },
        // get list data
        organizationsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.organizationForEdit = undefined;
            state.floorPlans = undefined;
            state.organizationChart = undefined;
            state.organizationChartHour = undefined;
            state.organizationChartHourZone = undefined;
        },
        // createOrganization
        organizationCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateOrganization
        organizationUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // organizationDeleted
        organizationDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
